import { META_FALLBACK_IMAGE } from '../constants'
import { Centre } from '../../types/centre'
import { fullCentreTitle } from './full-centre-title'
import { getCentreStructuredData } from './get-centre-structured-data'

export const getDefaultCentreMetadata = ({
  canonical,
  centre,
}: {
  canonical: string
  centre: Pick<
    Centre,
    | 'title'
    | 'suburb'
    | 'state'
    | 'postcode'
    | 'physicalAddress'
    | 'facebook'
    | 'instagram'
  >
}): {
  title: string
  description: string
  openGraphData: Record<string, any> | null
  schema: Record<string, any> | null
} => {
  const title = fullCentreTitle(centre)
  const description = `Westfield ${centre.title} - your one-stop hub for shopping, fun & relaxation. Shop our range of fashion, entertainment, dining & wellbeing or check out great events & activities.`
  return {
    title,
    description,
    // TODO: In event a url is not available don't return incomplete structured data
    openGraphData: canonical
      ? {
          url: canonical,
          type: 'ShoppingCenter',
          title,
          description,
          image: META_FALLBACK_IMAGE,
        }
      : null,
    schema: getCentreStructuredData({
      url: canonical,
      centre,
      name: title,
      description,
    }),
  }
}
